import React, { useEffect } from "react";
import {
  Button,
  Typography,
  makeStyles,
  useTheme,
  Tooltip,
} from "@material-ui/core"; // Import Tooltip
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Paper from "@mui/material/Paper";
import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import {
  formatNumber,
  formatWOWValue,
  formatDate,
  formatDatePlus8Week,
} from "../../hooks/Formatter";
import Loading from "../Loading";
import { connect, useSelector } from "react-redux";
import powerBiLogo from "../../../assets/images/power-bi-logo.png";
import { formatToKOrMWithoutDecimal } from "../../../helper";
const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "12px",
    background: "#FFF",
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
  },
  header: {
    display: "flex",
    // justifyContent: 'space-between',
    alignItems: "center",
    height: "30px",
  },
  title: {
    color: "#333333 !important",
    fontFamily: "Poppins, sans-serif",
    fontSize: "14px",
    fontWeight: "500 !important",
    marginLeft: "15px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      marginLeft: "10px",
    },
  },
  value: {
    fontFamily: "Poppins, sans-serif",
    fontSize: "28.146px",
    fontWeight: "700",
    color: "#0067A1",
    [theme.breakpoints.down("sm")]: {
      fontSize: "24px",
    },
  },
  subtitle: {
    color: "#333",
    borderRadius: "5px",
    padding: "5px",
    fontFamily: "Poppins, sans-serif",
    fontSize: "10px",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: "8px",
      padding: "3px",
    },
  },
  cardContent: {
    padding: "10px",
    minWidth: "200px",
    flex: "1 1 auto",
    [theme.breakpoints.down("sm")]: {
      minWidth: "100%",
      padding: "10px 0",
    },
  },
  cardContainer: {
    display: "flex",
    flexWrap: "wrap",
    padding: "40px 10px 0px 10px",
    [theme.breakpoints.down("md")]: {
      flexDirection: "row",
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
    },
  },
  paper: {
    background: "rgba(255, 255, 255, 0.55)",
    borderRadius: "8px !important",
    height: "autp",
    boxShadow:
      "0px 1px 2px 0px rgba(0, 0, 0, 0.05), 0px 2px 16px 0px rgba(0, 0, 0, 0.10) !important",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "auto",
    },
  },
  activeTab: {
    color: "#FFF",
    fontFamily: "Poppins, sans-serif",
    fontSize: "10px",
    fontWeight: "500",
    lineHeight: "normal",
    background: " #0067A1",
    textTransform: "none",
    "&:hover ": {
      backgroundColor: "#0067A1",
    },
  },
  inActiveTab: {
    color: "#404041",
    fontFamily: "Poppins, sans-serif",
    fontSize: "10px",
    fontWeight: "500",
    lineHeight: "normal",
    textTransform: "none",
    background: "#F7F7F7",
    "&:hover ": {
      backgroundColor: "#F7F7F7",
    },
  },
  wowIConRed: {
    verticalAlign: "middle",
    color: "#E01F29",
    background: "#FBE8E9",
    borderRadius: "10px",
    margin: "0px 5px 0px 0px",
    width: "22px",
    height: "19px",
    flexShrink: 0,
    fontSize: "11px",
  },
  wowIconGreen: {
    verticalAlign: "middle",
    color: "#24A148",
    background: "#00E6761F",
    borderRadius: "10px",
    margin: "0px 5px 0px 0px",
    width: "22px",
    height: "19px",
    flexShrink: 0,
    fontSize: "11px",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "20vh",
    width: "100%",
    position: "relative",
    top: 0,
    left: 0,
  },
  refresh: {
    padding: "10px 8px",
    color: "var(--Neutrals-Grey-darker, #404041)",
    fontFamily: "Poppins, sans-serif",
    fontSize: "15px",
    lineHeight: "normal",
    borderRadius: "13px 0px",
    fontWeight: 500,
    border: "1px solid var(--Neutrals-Grey-light, #E6E7E8)",
    background: "#F7F7F7",
    position: "absolute",
    top: 0,
    left: 0,
  },
  period: {
    display: "flex",
    position: "absolute",
    top: 0,
    right: 0,
  },
  card: {
    padding: "0px 15px",
  },
  threshold: {
    color: "#929497",
    fontSize: "10.813px",
  },
  wowData: {
    display: "flex",
    alignItems: "center",
    padding: "10px 10px 10px 15px",
  },
  wowDataRed: {
    fontSize: "12px !important",
    fontWeight: "600 !important",
    color: "#E01F29 !important",
  },
  wowDataRedFGS: {
    fontSize: "20px !important",
    fontWeight: "600 !important",
    color: "#E01F29 !important",
  },
  wowDataGreen: {
    fontSize: "12px !important",
    fontWeight: "600 !important",
    color: "#24A148 !important",
  },
  wowDataGreenFGS: {
    fontSize: "20px !important",
    fontWeight: "600 !important",
    color: "#24A148 !important",
  },
  wowText: {
    color: "#A2A5AE !important",
    fontSize: "12px !important",
    fontWeight: "600 !important",
    marginLeft: "5px",
  },
  wowTextFGS: {
    color: "#A2A5AE !important",
    fontSize: "20px !important",
    fontWeight: "600 !important",
    marginLeft: "5px",
  },
  wowFFText: {
    color: "#A2A5AE !important",
    fontSize: "15px !important",
    fontWeight: "600 !important",
    marginLeft: "5px",
  },
  ffValue: {
    fontFamily: "Poppins, sans-serif",
    fontSize: "19.146px",
    fontWeight: "600",
    color: "#0067A1",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
}));

const KPICard = ({
  cardContent,
  position,
  _margin,
  loading,
  Module,
  periodType,
  periodTypeFilterChange,
  handleViewPowerBi,
}) => {
  const classes = useStyles();
  // const theme = useTheme();
  // const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const data = cardContent;
  let path = window.location.pathname;
  const getWOWIcon = (value, item) => {
    if (
      item === "Redeployment Cost" ||
      item === "Recommended STRs for today" ||
      item === "Past due STOs from 28 days" ||
      item === "Recommended TLs Today"
    ) {
      if (value < 0) {
        return <ArrowDownwardOutlinedIcon className={classes.wowIconGreen} />;
      } else {
        return <ArrowUpwardOutlinedIcon className={classes.wowIConRed} />;
      }
    } else {
      if (value < 0) {
        return <ArrowDownwardOutlinedIcon className={classes.wowIConRed} />;
      } else {
        return <ArrowUpwardOutlinedIcon className={classes.wowIconGreen} />;
      }
    }
  };

  const lastRefreshData = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);

    // Validate both dates
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      return "";
    }

    // Shared configuration
    const timeZone = "America/Los_Angeles";
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone,
      month: "short",
      day: "2-digit",
    });

    // Helper to extract date parts safely
    const getDateParts = (date) => {
      const parts = formatter.formatToParts(date);
      const result = {};
      for (const part of parts) {
        if (part.type === "month") {
          result.month = part.value;
        }
        if (part.type === "day") {
          result.day = part.value;
        }
      }

      return result;
    };

    // Get parts for both dates
    const startParts = getDateParts(startDate);
    const endParts = getDateParts(endDate);

    // Validate extracted parts
    if (
      !startParts.day ||
      !startParts.month ||
      !endParts.day ||
      !endParts.month
    ) {
      return "";
    }

    // Format final string
    return `- Metric for week of ${
      startParts.day
    }/${startParts.month.toUpperCase()} vs. ${
      endParts.day
    }/${endParts.month.toUpperCase()}.`;
  };

  const bindKPIWOWDODData = (data, item, Module) => {
    console.log("Module>>>>>>>>>>>", Module);
    if (data[item].DOD) {
      return (
        <>
          {getWOWIcon(data[item].DOD, item)}
          <Typography
            className={
              item === "Recommended STRs for today" ||
              item === "Past due STOs from 28 days" ||
              item === "Recommended TLs Today"
                ? data[item].DOD > 0
                  ? classes.wowDataRed
                  : classes.wowDataGreen
                : data[item].DOD > 0
                  ? classes.wowDataGreen
                  : classes.wowDataRed
            }
          >
            {formatWOWValue(data[item].DOD)}%
          </Typography>
          <Typography className={classes.wowText}>DoD</Typography>
        </>
      );
    } else if (data[item].WOW) {
      console.log("data[item].WOW>>>>>>>>>>>>>");
      if (Module === "POOS") {
        if (Number.isFinite(data[item].WOW)) {
          return (
            <>
              {getWOWIcon(data[item].WOW, item)}
              <Typography
                className={
                  item === "Redeployment Cost" ||
                  item === "Recommended STRs for today" ||
                  item === "Past due STOs from 28 days" ||
                  item === "Recommended TLs Today"
                    ? data[item].WOW > 0
                      ? classes.wowDataRed
                      : classes.wowDataGreen
                    : data[item].WOW > 0
                      ? classes.wowDataGreen
                      : classes.wowDataRed
                }
              >
                {formatWOWValue(data[item].WOW)}%
              </Typography>
              {window.location.pathname !== "/nps" &&
                (window.location.pathname === "/iofpb" ? (
                  <Typography className={classes.wowText}>
                    Week over Week
                  </Typography>
                ) : (
                  <Typography className={classes.wowText}>WoW</Typography>
                ))}
            </>
          );
        } else {
          return "";
        }
      } else {
        return (
          <>
            {getWOWIcon(data[item].WOW, item)}
            <Typography
              className={
                item === "Redeployment Cost" ||
                item === "Recommended STRs for today" ||
                item === "Past due STOs from 28 days" ||
                item === "Recommended TLs Today"
                  ? data[item].WOW > 0
                    ? window.location.pathname === "/fgs"
                      ? classes.wowDataRedFGS
                      : classes.wowDataRed
                    : window.location.pathname === "/fgs"
                      ? classes.wowDataGreenFGS
                      : classes.wowDataGreen
                  : data[item].WOW > 0
                    ? window.location.pathname === "/fgs"
                      ? classes.wowDataGreenFGS
                      : classes.wowDataGreen
                    : window.location.pathname === "/fgs"
                      ? classes.wowDataRedFGS
                      : classes.wowDataRed
              }
            >
              {formatWOWValue(data[item].WOW)}%
            </Typography>
            {window.location.pathname !== "/nps" &&
              (window.location.pathname === "/iofpb" ? (
                <Typography className={classes.wowText}>
                  Week over Week
                </Typography>
              ) : (
                <Typography
                  className={
                    window.location.pathname === "/fgs"
                      ? classes.wowTextFGS
                      : classes.wowText
                  }
                >
                  WoW
                </Typography>
              ))}
          </>
        );
      }
    } else if (data[item].MOM) {
      return (
        <>
          {getWOWIcon(data[item].MOM, item)}
          <Typography
            className={
              item === "Redeployment Cost"
                ? data[item].MOM > 0
                  ? window.location.pathname === "/fgs"
                    ? classes.wowDataRedFGS
                    : classes.wowDataRed
                  : window.location.pathname === "/fgs"
                    ? classes.wowDataGreenFGS
                    : classes.wowDataGreen
                : data[item].WOW > 0
                  ? window.location.pathname === "/fgs"
                    ? classes.wowDataGreenFGS
                    : classes.wowDataGreen
                  : window.location.pathname === "/fgs"
                    ? classes.wowDataRedFGS
                    : classes.wowDataRed
            }
          >
            {formatWOWValue(data[item].MOM)}%
          </Typography>
          <Typography className={classes.wowText}>MoM</Typography>
        </>
      );
    } else if (data[item].change) {
      // console.log("4")
      return (
        <>
          {getWOWIcon(data[item].change, item)}
          <Typography
            className={
              data[item].change > 0 ? classes.wowDataGreen : classes.wowDataRed
            }
          >
            {formatWOWValue(data[item].change)}%
          </Typography>
          {item === "COF" &&
          !["/slp", "/iofpb", "/iof"].includes(window.location.pathname) ? (
            <Typography className={classes.wowText}>
              vs Base model run
            </Typography>
          ) : (
            <Typography className={classes.wowText}>WOW</Typography>
          )}
        </>
      );
    } else {
      return null;
    }
  };
  // Helper to format large numbers with suffixes
  const formatLargeNumber = (num) => {
    const absNum = Math.abs(num);
    let formatted = "";
    if (absNum >= 1_000_000_000) {
      formatted = `${formatNumber(absNum / 1_000_000_000)}B`;
    } else if (absNum >= 1_000_000) {
      formatted = `${formatNumber(absNum / 1_000_000)}M`;
    } else if (absNum >= 1_000) {
      formatted = `${formatNumber(absNum / 1_000)}K`;
    } else {
      formatted = formatNumber(absNum);
    }

    return num < 0 ? `-${formatted}` : formatted;
  };
  const formatValue = (value, KPI) => {
    if (value === null) {
      return "NA";
    }

    // Helper to format numbers with up to one decimal place
    // const formatNumber = (num) =>
    //   num
    //     .toFixed(1)
    //     .replace(/(\.\d*?[1-9])0+$/, "$1")
    //     .replace(/(\.0+|(?<=\.\d)0+)$/, "");

    // KPI-specific formatting logic
    const formatAsPercentage = (val) => `${Math.round(val)}%`;
    const formatAsCurrency = (val) => {
      const absValue = formatLargeNumber(Math.abs(val));
      return val < 0 ? `-$${absValue}` : `$${absValue}`;
    };
    switch (KPI) {
      case "COF":
      case "Primary Payload %":
      case "ST capacity utilization":
      case "LT capacity utilization":
      case "Weekly RDP accuracy":
        return formatAsPercentage(value);
      case "Detention spend %":
      case "Margin":
      case "Incident rate":
        return formatAsPercentage(value);
      case "Potential COF":
        return `${Math.round(value * 100)}%`;
      case "Potential savings through diverts":
      case "Cost of Fulfillment":
      case "Cost Per Case":
        return formatAsCurrency(value);
      case "Transportation spend":
        return formatAsCurrency(value);
      case "Detention spend":
        return formatAsCurrency(value);
      case "STR's Rejection Savings":
      case "Penalties":
        return `$${formatLargeNumber(value)}`;
      case "Inventory on hand":
        return `$${formatLargeNumber(value)}`;
      case "SalvageRisk in next 2 weeks":
        return `$${formatLargeNumber(value)} Cases`;
      case "National Salvage Risk in next 2 weeks":
        return `${formatLargeNumber(value)} Cases`;
      case "SalvageRisk in 2 weeks":
        return `$${formatLargeNumber(value)}`;
      case "National Salvage Risk in 2 weeks":
        return `$${formatLargeNumber(value)}`;
      case "Potential Savings in Next 2 weeks":
        return `$${formatLargeNumber(value)}`;
      case "Redeployment Cost":
        return `$${formatLargeNumber(value)}`;
      case "Working Capital Today":
      case "Waste, Projected this week":
        return `$${formatLargeNumber(value)}`;
      case "COF Last week":
        return formatAsPercentage(value);
      case "NPOOS Value at Risk":
      case "RPOOS Value at risk":
        return `$${formatLargeNumber(value)}`;
      case "NPOOS SKUs at risk":
      case "RPOOS SKUs at risk":
        return formatToKOrMWithoutDecimal(value);
      case "Transport spend":
      case "Value":
        return `$${formatLargeNumber(value)}`;

      case "Ordered revenue":
      case "Add shipping cost":
      case "$ Fines averted":
        return `$${formatLargeNumber(value)}`;

      case "# of Active Events":
      case "# of Order diverts recom":
        return value?.toFixed(0);

      case "Revenue":
        return `$${formatLargeNumber(value)}`;
      case "Cost":
        return `$${formatLargeNumber(value)}`;
      case "Storage Utilization":
        return `${Math.round(value * 100)}%`;
      case "Outbound Dock Utilization":
        return `${Math.round(value * 100)}%`;
      case "Stockouts":
        return `${formatLargeNumber(value)}`;
      case "Risky Lanes":
        return `${Math.floor(formatLargeNumber(value))}`;
      case "Waste/NNS%":
        return formatAsPercentage(value);
      case "Savings":
        return formatAsCurrency(value);
      case "$ Per case":
        return formatAsCurrency(value);

      case "Inbound Dock Utilization":
        return `${Math.floor(formatLargeNumber(value) * 100)}%`;
      case "Ordered Revenue":
      case "Actionable Revenue":
        return formatAsCurrency(value);
      case "Order value":
        return `$${formatLargeNumber(value)}`;

      case "Order Excep NPS":
        return `$${formatLargeNumber(value)}`;
      case "Qty Cuts (RRR%)":
        return formatAsPercentage(value);
      case "Late Loads (RRR%)":
        return formatAsPercentage(value);

      case "% of orders stockouts":
        return formatAsPercentage(value);

      case "% of orders with blocks":
        return formatAsPercentage(value);

      case "Avg # of Parameters with 0 weightage":
        return value;
      case "# of Scenerios Per Day":
        return value?.toFixed(2);
      case "Recommended scenarios implemented":
        return value;

      case "# Orders pushed - Customer":
      case "# Orders pushed - Nestle":
      case "Order diverted this month":
        return value?.toFixed(0);
      case "Avg days of pushout":
      case "Avg days before RDD":
        return value?.toFixed(2);
      case "Expected OT for current month Nestle":
        return `${value?.toFixed(0)}%`;
      case "Expected OT for current month Customer":
      case "Potential Order Diverts":
        return `${value?.toFixed(0)}`;
      default:
        return typeof value === "number" ? formatLargeNumber(value) : value;
    }
  };

  useEffect(() => {
    periodTypeFilterChange(
      Module === "DETENTION" || Module === "TM" ? "MOM" : "WOW",
    );
  }, []);

  const handlePeriodClick = (value) => {
    periodTypeFilterChange(value);
  };
  const getTooltipTitle = (item) => {
    switch (item) {
      case "COF":
        return "From DOM. COF of orders with delivery date in the last 7 days from refresh date.";
      case "Cost Per Case":
        return "From Transportation data - Average cost per case delivered to customers through FTLs in the last 7 days and Delivery Type is LF.";
      case "Cost of Fulfillment":
        return "From Transport data: Average cost of delivery per DC with delivery date in the last 7 days through FTL  and Delivery Type is LF.";
      case "Potential COF":
        return "From DOM - Potential COF after if today's DOM recommendations are implemented";
      case "Potential Order Diverts":
        return "From DOM - # of diverts recommended to be implemented today";
      case "Potential Savings through diverts":
        return "From DOM - Savings in fulfillment cost/fines through recommendations today";
      case "Order diverted this month":
        return "From DOM - Order diverts implemented this month";
      // Add more cases as needed for each KPI
      case "Recommended STRs for today":
        return "From the latest DO refresh: Count of STRs approved where STR status is Accepted.  Filters applicable: Material, PL3, Division, DC, Network. WoW comparison for same day last week";
      case "Past due STOs from 28 days":
        return 'From Past Dues used in DO: Distinct STO/POs where the delivery date should be between 4 weeks ago till date and the order status is "Order" or "Shipped". Filters applicable: Material, PL3, Division, DC, Network. WoW comparison for same day last week';
      case "Recommended TLs Today":
        return "From the latest DO refresh: Sum of the weights of the STRs approved converted to Truckload(44,500lbs) equivalents.Filters applicable: Material, PL3, Division, DC, Network. WoW comparison for same day last week";
      case `STR's Rejection Savings`:
        return "From Redeployment: Sum of the variance amount for shipments made in last 7 days. Filters applicable: Material, PL3, Division, DC, Network";
      case "Primary Payload %":
        return "From Material Deployment: % weight utilization of a Truck capacity for primary deployments in the time period selected. Filters applicable: Material, PL3, Division, DC, Network";
      case "Redeployment Cost":
        return "From Redeployment: Sum of the variance amount for shipments made in last 7 days. Filters applicable: Material, PL3, Division, DC, Network";

      case "Booked Capacity(TLs)":
        return "From latest Freight Forecast output. Total TLs awarded for the next 8 weeks";
      case "Shortage TLs":
        return "From latest Freight Forecast output. Sum of Forecast minus awards for the next 8 weeks where the awards are less than forecast";
      case "Excess Awards (TLs)":
        return "From latest Freight Forecast output. Sum of Awards minus forecast for the next 8 weeks where the awards are less than forecast";
      case "Transport spend":
        return "From latest Freight Forecast output and chain analytics. Total cost of awards based on the freight rates";

      case "ST capacity utilization":
        return "For Next 35 Days";
      case "LT capacity utilization":
        return "For Next 78 Weeks";
      case "Weekly RDP accuracy":
        return "For Last 2 Weeks";

      case "Transportation spend":
        return "Total amount spent in transportation in last 90 days. Taken from detention spend optimization output.</br>Where the Acc location type is 3rd Party, Nestle DC, Callout or Customer.";
      case "Detention spend":
        return "Total amount spent in detention claims in last 90 days. Taken from detention spend optimization output.</br>Where the Acc location type is 3rd Party, Nestle DC, Callout or Customer.";
      case "Detention spend %":
        return "Detention spend as a % of Transportation for last 90 days.</br>Where the Acc location type is 3rd Party, Nestle DC, Callout or Customer.";
      case "Incident rate":
        return "Number of detention claims as a % of the total transport orders in the last 90 days.</br>Where the Acc location type is 3rd Party, Nestle DC, Callout or Customer.";

      case "# Orders pushed - Customer":
        return "# of orders with original Delivery date in current month and with RDD pushed out due to customer attributed reason codes";
      case "# Orders pushed - Nestle":
        return "# of orders with original Delivery date in current month and with RDD pushed out due to Nestle attributed reason codes";
      case "Avg days of pushout":
        return "Avg # of days of difference between Original delivery date and revised delivery date";
      case "Avg days before RDD":
        return "Avg # of days before the Original RDD that the RDD revision was made";
      case "Expected OT for current month Nestle":
        return "% of orders without RDD delays attributed to Nestle reason codes out of all orders with Original RDD in the current month";
      case "Expected OT for current month Customer":
        return "% of orders without RDD delays attributed to Customer reason codes out of all orders with Original RDD in the current month";
      case "NPOOS Value at Risk":
        return "National POOS Value at risk in next 4 weeek.";
      case "RPOOS SKUs at risk":
        return "Regional POOS SKUs at Risk in next 4 weeeks.";
      case "RPOOS Value at risk":
        return "Regional POOS Value at risk in next 4 weeeks.";
      case "NPOOS SKUs at risk":
        return "National POOS SKUs at Risk in next 4 weeeks.";
      case "Risky Lanes":
        return "From latest Freight Forecast output. Lanes that have a forecast that is 120% more than awards for 3/8 weeks in a lane without a single dominant carrier.";
      case "Inventory on hand":
        return "From FG Salvage module output: Sum of FG inventory on hand in dollars as of refresh date.";
      case "National Salvage Risk in next 2 weeks":
        return "From FG Salvage module. Number of cases of FG in DCs that are at risk of becoming non-sellable in the next 2 weeks.";
      case "National Salvage Risk in 2 weeks":
        return "From FG Salvage module. Value of FG in DCs that are at risk of becoming non-sellable in the next 2 weeks.";
      case "Potential Savings in Next 2 weeks":
        return "From FG Salvage module. FG at salvage risk with opportunity to be sold in the next 2 weeks by transferring to DCs with demand.";
      case "Working Capital Today":
        return "From FG Salvage: Sum of the inventory $ across the network in the latest refresh.<br/>Filters applicable: Network, DC, PL3, Division, SKUs";
      case "Waste, Projected this week":
        return "From FG Salvage: Sum of the inventory $ that are at risk of becoming non-saleable across the network as per the latest refresh. <br/> Filters applicable: Network, DC, PL3, Division, SKUs";
      case "COF Last week":
        return "From COF Dashboard: COF average achieved last week.<br/> Filters applicable: Network, DC";
      case "Throughput next 5 weeks":
        return `From Capacity Planning: Sum of the throughputs across DCs in the network over the next 5 weeks as per the latest Long Term Capacity Plan.<br/> Filters applicable: Network, DC`;
      case "Ordered Revenue":
        return "Sum of the ordered revenue for orders planned to be delivered in the next 14 days.Excludes orders with credit block, delivery block or billing block.<br/>Filters applicable: Network, DC, PL3, CL6, SKUs, Sold to Customer";
      case "Actionable Revenue":
        return "Sum revenue for lineitems with issues that have recommended actions across ordersFor orders planned to be delivered in the next 14 days.Excludes orders with credit block, delivery block or billing block.<br/>Filters applicable: Network, DC, PL3, CL6, SKUs, Sold to Customer";
      case "% of orders stockouts":
        return "% of orders planned for delivery in the next 14 days that have a regional or national out of stock item.<br/>Filters applicable: Network, DC, PL3, CL6, SKUs, Sold to Customer";
      case "% of orders with blocks":
        return "% of orders planned for delivery in the next 14 days that have a delivery block, credit block or billing block.<br/>Filters applicable: Network, DC, PL3, CL6, SKUs, Sold to Customer";
      case "Revenue":
        return "Revenue achievable through the recommended config for the selected scenario";
      case "Cost":
        return "Cost estimated for the recommended config for the selected scenario";
      case "Stockouts":
        return "Stockouts expected through the recommended config for the selected scenario";
      case "Storage Utilization":
        return "Storage Utilization of DCs expected through the recommended config for the selected scenario";
      case "Outbound Dock Utilization":
        return "Outbound dock capacity utilization expected through the recommended config for the selected scenario";
      case "Inbound Dock Utilization":
        return "Inbound dock capacity utilization expected through the recommended config for the selected scenario";
      case "# of Active Events":
        return "# of ongoing DC shutdown events as of today";
      case "# of Order diverts recom":
        return "Delivery orders recommended for diverting from the affected DC";
      case "Ordered revenue":
        return "Sum of ordered revenue across all orders that are to be fulfilled by a DC affected by ongoing events";
      case "$ Fines averted":
        return "Sum of penalty charges averted across all orders that are recommended to be fulfilled from an alternative DC";
      case "Add shipping cost":
        return "Estimated additional shipping cost incurred for fulfilling orders from a diverted DC";
      case "# of Scenerios Per Day":
        return "# of scenarios generated in the last 3 days using the Intelligent Order Fulfillment powerapp tool.";
      case "Recommended scenarios implemented":
        return "Count of recommendations from scenarios which have been pushed to SAP on the last 14 days";
      case "Avg # of Parameters with 0 weightage":
        return "Out of the 10 different parameters provided for the scenario- average count of parameters with weightage of 0 across all scenarios that were run in the last 3 days.";
      case "Open Exception-DOC":
        return "# of distinct sales order documents with exceptions where requested delivery is in the last 7 days and Sales activity status is not closed.";
      case "Order Excep NPS":
        return "NPS of orders with Requested delivery dates in the last 7 days that where the reject reason is not NS, WH or 3A";
      case "Qty Cuts (RRR%)":
        return "% of orders with quantity cut exceptions out of all orders with requested delivery date in the last 7 days";
      case "Late Loads (RRR%)":
        return "% of orders with late loads out of all orders with requested delivery date in the last 7 days";
      default:
        return "This is additional information about the KPI";
    }
  };
  // const reduxUserDetails = useSelector((state) => state) || [];

  let startDate;
  let endDate;
  if (data?.["Recommended STRs for today"]?.startDate) {
    startDate = data?.["Recommended STRs for today"]?.startDate;
    endDate = data?.["Recommended STRs for today"]?.endDate;
  } else {
    startDate = data?.COF?.startDate;
    endDate = data?.COF?.endDate;
  }

  function getFormattedValue(num) {
    const absNum = Math.abs(num);
    let formatted = "";
    if (absNum >= 1_000_000_000) {
      formatted = `${formatNumber(absNum / 1_000_000_000)}B`;
    } else if (absNum >= 1_000_000) {
      formatted = `${formatNumber(absNum / 1_000_000)}M`;
    } else if (absNum >= 1_000) {
      formatted = `${formatNumber(absNum / 1_000)}K`;
    } else {
      formatted = formatNumber(absNum);
    }

    return formatted;
  }

  function getDisplayText(item, path, Module, data) {
    if (path === "/poos") {
      return "";
    } else if (Module === "SNO") {
      return "";
    } else if (item === "Potential COF" || item === "COF") {
      return Module === "IF" ? "Target-98.5%" : "Threshold 95%";
    } else if (path === "/nps") {
      if (item === "Revenue" || item === "Cost" || item === "Stockouts") {
        const delta = data[item].delta;
        const formattedDelta = `${delta < 0 ? "-$" : "+$"}${getFormattedValue(
          data[item].delta,
        )}`;
        return (
          <>
            Recommended vs. Scenario Constrained:{" "}
            <strong>
              <span style={{ fontSize: "1.3em" }}>{formattedDelta}</span>
            </strong>
          </>
        );
      } else {
        return "Recommended vs Scenario Unconstrained";
      }
    } else if (path === "/ff") {
      return (
        <>
          vs Last Week:{" "}
          <strong>
            {formatLargeNumber(data[item].MOM ? data[item].lm : data[item].lw)}
          </strong>
        </>
      );
    } else if (item === "Waste/NNS%" && Module === "IF") {
      return "Target-0.93%";
    } else if (item === "Savings" && Module === "IF") {
      return "Target-$70M";
    } else if (item === "$ Per case" && Module === "IF") {
      return "Target-0.36";
    } else if (Module !== "RR") {
      return "NA";
    } else {
      return "";
    }
  }

  return (
    <Paper
      elevation={0}
      style={{
        position: position,
      }}
      className={classes.paper}
    >
      {loading ? (
        <div className={classes.loader}>
          <Loading />
        </div>
      ) : (
        <>
          {Module === "DOM" ? (
            <Typography className={classes.refresh}>
              <b>Today </b>
              {""}
              <span>Last Refresh - {formatDate(data.latestDate)}</span>
            </Typography>
          ) : (
            <Typography className={classes.refresh}>
              {window.location.pathname === "/ff" ? (
                <>
                  <b>Next 8 weeks -</b>
                  <span>{`Last Refresh: ${formatDate(
                    data.latestDate,
                  )} ${lastRefreshData(startDate, endDate)}`}</span>
                </>
              ) : ["/iof"].includes(window.location.pathname) ? (
                <b>{`Selected Scenario next 2 weeks - Scenario created date:${formatDate(
                  data.latestDate,
                )}`}</b>
              ) : ["/erm"].includes(window.location.pathname) ? (
                <b>{`Last 1 week- Last refresh ${formatDate(
                  data.latestDate,
                )}`}</b>
              ) : ["/slp"].includes(window.location.pathname) ? (
                <>
                  <b>{`Next 2 weeks - Last refresh ${formatDate(
                    data.latestDate,
                  )}`}</b>
                </>
              ) : (
                <>
                  {![
                    "/nps",
                    "/rr",
                    "/cp",
                    "/dip",
                    "/poos",
                    "/ds",
                    "/if",
                    "/iofpb",
                  ].includes(window.location.pathname) && <b>Last 7 Days -</b>}
                  {window.location.pathname === "/ds" && <b>Last 90 Days -</b>}
                  {window.location.pathname === "/if" && <b>Last 4 Weeks -</b>}
                  {window.location.pathname === "/iofpb" && (
                    <b>Current Month -</b>
                  )}
                  <span>
                    {" "}
                    {`Last Refresh: ${formatDate(
                      Module === "IOFPB" ? data.time : data.latestDate,
                      Module === "IOFPB",
                    )} ${lastRefreshData(startDate, endDate)}`}
                  </span>
                </>
              )}
            </Typography>
          )}
          {window.location.pathname !== "/nps" &&
            (window.location.pathname === "/dp" ||
            window.location.pathname === "/dip" ||
            // Module === "POOS" ||
            Module === "FF" ||
            window.location.pathname === "/tm" ? ( // Added "/tm" condition
              <div className={classes.period}>
                {window.location.pathname === "/tm" ? ( // Conditionally render only "MoM" for "/tm"
                  <Button
                    className={
                      periodType === "MOM"
                        ? classes.activeTab
                        : classes.inActiveTab
                    }
                    onClick={() => handlePeriodClick("MOM")}
                    style={{
                      borderRadius: "0px 0px 0px 8px",
                      border: "1px solid var(--Neutrals-Grey-light, #E6E7E8)",
                    }}
                  >
                    MoM
                  </Button>
                ) : (
                  <>
                    <Button
                      className={
                        periodType === "WOW"
                          ? classes.activeTab
                          : classes.inActiveTab
                      }
                      onClick={() => handlePeriodClick("WOW")}
                      style={{
                        borderRadius: "0px 0px 0px 8px",
                        border: "1px solid var(--Neutrals-Grey-light, #E6E7E8)",
                      }}
                    >
                      WoW
                    </Button>
                    <Button
                      className={
                        periodType === "MOM"
                          ? classes.activeTab
                          : classes.inActiveTab
                      }
                      onClick={() => handlePeriodClick("MOM")}
                      style={{ borderRadius: "0px 0px 0px 0px" }}
                    >
                      MoM
                    </Button>
                  </>
                )}
              </div>
            ) : (
              <div className={classes.period}>
                {["/slp", "/iofpb", "/iof", "/erm"].includes(
                  window.location.pathname,
                ) ? null : (
                  <>
                    {!["DETENTION", "RR", "IF", "POOS"]?.includes(Module) && (
                      <Button
                        className={
                          periodType === "WOW"
                            ? classes.activeTab
                            : classes.inActiveTab
                        }
                        onClick={() => handlePeriodClick("WOW")}
                        style={{
                          borderRadius: "0px 0px 0px 8px",
                          border:
                            "1px solid var(--Neutrals-Grey-light, #E6E7E8)",
                        }}
                      >
                        WoW
                      </Button>
                    )}
                    {Module === "SNO" ||
                    Module === "FGS" ||
                    Module === "CP" ||
                    Module === "DETENTION" ? (
                      <Button
                        className={
                          periodType === "MOM"
                            ? classes.activeTab
                            : classes.inActiveTab
                        }
                        onClick={() => handlePeriodClick("MOM")}
                        style={{
                          border:
                            "1px solid var(--Neutrals-Grey-light, #E6E7E8)",
                          borderRadius: "0px",
                        }}
                      >
                        MoM
                      </Button>
                    ) : (
                      !["RR", "IF", "POOS"]?.includes(Module) && (
                        <Button
                          className={
                            periodType === "DOD"
                              ? classes.activeTab
                              : classes.inActiveTab
                          }
                          onClick={() => handlePeriodClick("DOD")}
                          style={{
                            border:
                              "1px solid var(--Neutrals-Grey-light, #E6E7E8)",
                            borderRadius: "0px",
                          }}
                        >
                          DoD
                        </Button>
                      )
                    )}
                  </>
                )}
              </div>
            ))}
          <div className={classes.cardContainer}>
            {Object.keys(data)
              .filter((item) => item !== "latestDate")
              .map((item) => (
                <div className={classes.cardContent} key={item}>
                  <div className={classes.header}>
                    <Typography className={classes.title}>{item}</Typography>
                    {window.location.pathname === "/do" && (
                      <Tooltip title="Open in Power BI" placement="top">
                        <img
                          src={powerBiLogo}
                          alt="Power BI"
                          style={{
                            width: "30px",
                            height: "20px",
                            marginLeft: "5px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleViewPowerBi(item)}
                        />
                      </Tooltip>
                    )}
                    <Tooltip
                      title={
                        <span
                          dangerouslySetInnerHTML={{
                            __html: getTooltipTitle(item),
                          }}
                        />
                      }
                      placement="top"
                    >
                      <InfoOutlinedIcon
                        fontSize="small"
                        style={{
                          color: "blue",
                          marginLeft: "5px",
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                  </div>
                  <div className={classes.card}>
                    <Typography
                      className={
                        path === "/ff" ? classes.ffValue : classes.value
                      }
                    >
                      {path === "/ff"
                        ? formatValue(data[item].cw, item)
                        : formatValue(data[item].value, item)}
                    </Typography>
                    {[
                      "/slp",
                      "/iofpb",
                      "/iof",
                      "/erm",
                      "/ds",
                      "/dom",
                      "/fgs",
                      "/do",
                      "/dp",
                      "/dip",
                      "/cp",
                    ].includes(window.location.pathname) ? null : (
                      <Typography className={classes.threshold}>
                        {getDisplayText(item, path, Module, data)}
                      </Typography>
                    )}
                  </div>
                  <div className={classes.wowData}>
                    {bindKPIWOWDODData(data, item, Module)}
                  </div>
                </div>
              ))}
          </div>
        </>
      )}
    </Paper>
  );
};

const mapStateToProps = (state) => ({
  periodType: state.filter.periodType,
});

const mapDispatchToProps = (dispatch) => ({
  periodTypeFilterChange: (newValue) =>
    dispatch({ type: "FILTER_PERIOD_TYPE", payload: newValue }),
});

export default connect(mapStateToProps, mapDispatchToProps)(KPICard);
